<div class="window-container">

<div *ngIf="screenToShow == 'settings'">

  <div class="container">
    <div>
      <img class="profile-pic" [src]="getProfilePic()">
    </div>
    <div class="account-infos">
      <p><span class="title">{{getString('email')}}</span>
      <br><span>{{email}}</span></p>
      <div class="title">{{getString('username')}}</div>
      <div>{{username}}</div>
    </div>
  </div>

  <div class="container">
    <div class="center-box">
      <div class="title">{{getString('accountProvider')}}</div>
      <img class="provider-img" [src]="getProviderImg()">
      <div class="provider-name">{{getProviderName()}}</div>
    </div>
    <span class="action" (click)="changeToApple()" *ngIf="provider != 'apple'">{{getString('changeToApple')}}</span>
  </div>

  <div class="container txt-algn-cntr">
    <div class="action" (click)="changeEmail()" *ngIf="provider == 'standard'">{{getString('changeEmail')}}</div>
    <div class="action" (click)="changeUsername()">{{getString('changeUsername')}}</div>
    <div class="action" (click)="changePassword()" *ngIf="provider == 'standard'">{{getString('changePassword')}}</div>
    <div class="action"  (click)="deleteAccount()">{{getString('deleteAccount')}}</div>
  </div>

  <div class="container txt-algn-cntr">
    <button (click)="close()" class="blue-button">{{getString('close')}}</button>
  </div>

</div>

<div *ngIf="screenToShow == 'changeToApple'">
  <p>{{getString('changeToAppleText')}}</p>
  <app-sign-in-apple [changeToApple]="true"></app-sign-in-apple>
  <button class="chng-aapl-btn" (click)="screenToShow = 'settings'">{{getString('cancel')}}</button>
</div>

<app-change-email *ngIf="screenToShow == 'changeEmail'" (close)="screenToShow = 'settings';getInfo()"></app-change-email>
<app-change-username *ngIf="screenToShow == 'changeUsername'" (close)="screenToShow = 'settings';getInfo()"></app-change-username>
<app-change-password *ngIf="screenToShow == 'changePassword'" (close)="screenToShow = 'settings';getInfo()"></app-change-password>

</div>